<template>
  <BModal
    active
    class="employee-bulk-upload"
    @close="closeModal"
  >
    <header class="modal-card-head">
      <p class="modal-card-title has-text-primary">
        Estatus de carga masiva
      </p>
    </header>
    <div class="table-container">
      <BTable
        :data="$store.state.employees.list"
        :columns="columns"
      >
        <template slot-scope="props">
          <BTableColumn
            field="name"
            label="Nombre"
            internal
          >
            {{ props.row.name }}
          </BTableColumn>
          <BTableColumn
            field="email"
            label="Email"
            internal
          >
            {{ props.row.email }}
          </BTableColumn>
          <BTableColumn
            field="message"
            label="message"
            internal
          >
            {{ props.row.message }}
          </BTableColumn>

          <BTableColumn
            field="status"
            label="status"
            internal
          >
            <BIcon
              v-if="props.row.success == false"
              icon="close"
              class="has-background-gray has-text-danger is-tooltip-left"
            />
            <BIcon
              v-if="props.row.success == true"
              class="has-background-gray has-text-success is-tooltip-left"
              icon="check"
            />
          </BTableColumn>
        </template>
      </BTable>
      <footer class="modal-card-foot">
        <button
          class="button"
          @click="closeModal"
        >
          Cerrar
        </button>
      </footer>
    </div>
  </BModal>
</template>

<script>
export default {
  name: 'EmployeeBulkLoadStatus',
  data() {
    return {
      columns: [
        { field: 'name', label: 'Nombre' },
        { field: 'email', label: 'Email' },
        { field: 'message', label: 'Respuesta' },
        { field: 'status', label: 'Estatus' },
      ],
    };
  },
  methods: {
    closeModal() {
      this.$router.push({ name: 'Customers' });
      this.loading = false;
    },
  },
};
</script>

<style scoped>
@media screen and (min-width: 769px) {
  form {
    max-width: 400px;
  }
}
</style>

<style>
.employee-bulk-upload .upload-draggable.is-primary {
  width: 100%;
}
</style>
